'use client';
import { Grid, Skeleton } from '@mui/material';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { LOADING_STATUS_PROPS, LoadingStatusText } from '../loadingStatus';
import { SafeSpacePadder } from '../safeSpace';

export const ClientRedirect = ({ redirectUrl, replace }: { redirectUrl: string; replace?: boolean }) => {
  const router = useRouter();
  useEffect(() => {
    if (replace) {
      router.replace(redirectUrl);
    } else {
      router.push(redirectUrl);
    }
  }, [redirectUrl, replace, router]);
  return (
    <SafeSpacePadder>
      <Grid
        {...LOADING_STATUS_PROPS}
        container
        sx={{
          flexDirection: 'column',
          flexWrap: 'nowrap',
          height: '100%',
          justifyContent: 'space-between',
          paddingBottom: { xs: 4, md: 0 },
          gap: 2,
        }}
      >
        <LoadingStatusText />
        <Grid sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Skeleton variant="rounded" animation="wave" sx={{ width: '80%', height: 44 }} />
          <Skeleton variant="rounded" animation="wave" sx={{ width: '40%', height: '2rem' }} />
          <Skeleton variant="rounded" animation="wave" sx={{ width: '100%', height: 44 }} />
          <Skeleton variant="rounded" animation="wave" sx={{ width: '40%', height: '2rem', mt: 2 }} />
          <Skeleton variant="rounded" animation="wave" sx={{ width: '100%', height: 44 }} />
          <Skeleton variant="rounded" animation="wave" sx={{ width: '100%', height: 44 }} />
        </Grid>
        <Skeleton variant="rounded" animation="wave" sx={{ width: '100%', height: 44, mt: 2 }} />
      </Grid>
    </SafeSpacePadder>
  );
};
